import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loading-controls',
  templateUrl: './loading-controls.component.html',
  styleUrls: ['./loading-controls.component.css']
})
export class LoadingControlsComponent implements OnInit {
  @Input() Msg: string;
  @Input() display: boolean;

  constructor() { }

  ngOnInit(): void {
    var checkExistloading = setInterval(function () {
      if ($('.loading').length != 0) {
        $('#mainscreen').append($('.loading'))
        clearInterval(checkExistloading);

      }
    }, 100); // check every 100ms
  }

}
